var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4929_31028)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.875 34.75H35C33.9645 34.75 33.125 35.5895 33.125 36.625V42.25C33.125 43.2855 33.9645 44.125 35 44.125C36.0355 44.125 36.875 43.2855 36.875 42.25V38.5H42.875C43.9105 38.5 44.75 37.6605 44.75 36.625C44.75 35.5895 43.9105 34.75 42.875 34.75Z",
    fill: "#61739F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 34.75H20.375C19.3395 34.75 18.5 35.5895 18.5 36.625C18.5 37.6605 19.3395 38.5 20.375 38.5H26.375V42.25C26.375 43.2855 27.2145 44.125 28.25 44.125C29.2855 44.125 30.125 43.2855 30.125 42.25V36.625C30.125 35.5895 29.2855 34.75 28.25 34.75Z",
    fill: "#61739F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 17.875C27.2145 17.875 26.375 18.7145 26.375 19.75V25H20.375C19.3395 25 18.5 25.8395 18.5 26.875C18.5 27.9105 19.3395 28.75 20.375 28.75H28.25C29.2855 28.75 30.125 27.9105 30.125 26.875V19.75C30.125 18.7145 29.2855 17.875 28.25 17.875Z",
    fill: "#7B86A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.875 25H36.875V19.75C36.875 18.7145 36.0355 17.875 35 17.875C33.9645 17.875 33.125 18.7145 33.125 19.75V26.875C33.125 27.9105 33.9645 28.75 35 28.75H42.875C43.9105 28.75 44.75 27.9105 44.75 26.875C44.75 25.8395 43.9105 25 42.875 25Z",
    fill: "#7B86A0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4929_31028",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4929_31028"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4929_31028",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullScreen);
export default __webpack_public_path__ + "static/media/exit_full_screen.145306081696cc406ea33f1810b6e1e8.svg";
export { ForwardRef as ReactComponent };